/**
 * Services Tab Prompt Builder
 *
 * Generates a component diagram prompt from business and technical service data.
 * Groups service components by domain.
 */

import type { BulkEAImport } from '../../canister-client';
import type { ChatMessage } from '../../canister-client';
import { baseSvgRules, summarizeEntities } from './base-svg-prompt';

export function buildServicesPrompt(data: BulkEAImport): ChatMessage[] {
    const bizSvcs = summarizeEntities(data.business_services, [
        'service_domain', 'business_service', 'service_offering', 'channel', 'sla', 'service_owner',
    ]);
    const techSvcs = summarizeEntities(data.technical_services, [
        'name', 'application', 'service_type', 'api_interface', 'availability_sla',
    ]);

    return [
        {
            role: 'user',
            content: `${baseSvgRules()}

DIAGRAM TYPE: Service Component Diagram

DATA - Business Services:
${bizSvcs}

DATA - Technical Services:
${techSvcs}

INSTRUCTIONS:
- Create a component diagram grouping services by "service_domain".
- Each domain is a large container with a colored header.
- Inside each domain, show service components as rounded boxes.
- Each component shows: service name, offering, channel, and SLA.
- Draw connections between business services and their technical services.
- Use green accent for service containers, blue for technical components.
- Add a title "Service Architecture" at the top.
- Arrange in 2-3 columns for readability.`,
        },
    ];
}
